// Shared select query for home data with all relations
export const HOME_SELECT_FIELDS = `
  *,
  address:addresses!homes_address_id_fkey(
    *,
    area:areas!addresses_area_id_fkey(id, name)
  ),
  status:status_id(*),
  images!images_home_id_fkey(*),
  viewings!viewings_home_id_fkey(
    *, 
    viewing_slots(
      *, 
      viewing_participants(*)
    )
  ),
  responsible_broker:responsible_broker_id(
    *,
    municipality:municipalities!brokers_municipality_id_fkey(id, name)
  ),
  additional_contact:additional_contact_id(
    *,
    municipality:municipalities!brokers_municipality_id_fkey(id, name)
  )
`;

// Extended select query for getHome with viewing slots and their participants
export const HOME_SELECT_FIELDS_EXTENDED = `
  *, 
  address:addresses!homes_address_id_fkey(
    *,
    area:areas!addresses_area_id_fkey(id, name)
  ),
  status:status_id(*),
  images!images_home_id_fkey(*),
  viewings!viewings_home_id_fkey(
    *,
    viewing_slots(
      *,
      viewing_participants(*)
    )
  ),
  responsible_broker:responsible_broker_id(
    *,
    municipality:municipalities!brokers_municipality_id_fkey(id, name)
  ),
  additional_contact:additional_contact_id(
    *,
    municipality:municipalities!brokers_municipality_id_fkey(id, name)
  )
`;
